import React from 'react';
import { Car, Wrench, Maximize, DoorOpen, ShieldAlert, Truck } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Windshield Replacement',
    copy: 'Fast windshield replacement for foreign and domestic cars, trucks, vans and SUVs, with quality glass options and certified installation.',
    icon: <Car className="w-6 h-6 text-brand-blue" data-id="element-590" data-mp="3rpjui0q15zeg" />
  }, {
    title: 'Windshield Chip Repair',
    copy: "Small stone chips may be repairable before they spread. Kosin's Glass can inspect the damage and recommend repair or replacement.",
    icon: <Wrench className="w-6 h-6 text-brand-blue" data-id="element-591" data-mp="abxvk8uol05s" />
  }, {
    title: 'Side Window Replacement',
    copy: 'Driver and passenger side window replacement, power window glass and quarter glass for cars, trucks and SUVs.',
    icon: <Maximize className="w-6 h-6 text-brand-blue" data-id="element-592" data-mp="2v02f2u18wyzk" />
  }, {
    title: 'Door Glass Replacement',
    copy: 'Car door glass replacement and repair for shattered or damaged door windows on most makes and models.',
    icon: <DoorOpen className="w-6 h-6 text-brand-blue" data-id="element-593" data-mp="397ghfji8vvx8" />
  }, {
    title: 'Rear Window Replacement',
    copy: 'Replacement for shattered or damaged rear vehicle glass, back windows and truck rear windows.',
    icon: <ShieldAlert className="w-6 h-6 text-brand-blue" data-id="element-594" data-mp="3j536uzx675vg" />
  }, {
    title: 'Truck, Semi & Fleet Glass',
    copy: 'Truck windshield repair, semi truck glass, commercial truck glass and fleet account service options.',
    icon: <Truck className="w-6 h-6 text-brand-blue" data-id="element-595" data-mp="3s5rn81a1dibi" />
  }];
  return <section className="py-16 lg:py-24 bg-white" data-id="element-596" data-mp="aq2sf8qurvq7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-597" data-mp="arw2ky0ocy2y">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-598" data-mp="5s17ei9v9mc3">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-599" data-mp="jq7wb8wu8bzm">
            Complete Auto Glass Repair & Replacement
          </h2>
          <p className="text-lg text-slate-600" data-id="element-600" data-mp="fqh2sxfxfhre">
            From cracked windshields to shattered side windows, Kosin's Glass
            repairs and replaces auto glass for domestic and foreign vehicles
            throughout Southeast Michigan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-601" data-mp="wp8s9yr0hogd">
          {services.map((service, index) => <div key={index} className="bg-slate-50 rounded-lg p-8 border border-slate-100 hover:shadow-lg hover:shadow-slate-200/50 transition-all duration-300 group scroll-fade-up" style={{
          animationDelay: `${index * 0.08}s`
        }} data-id="element-602" data-mp="11ibchg9wfljw" data-mpi={index}>
              <div className="w-14 h-14 bg-brand-light rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-603" data-mp="1fex8elq7f0bo">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-604" data-mp="3m77np16xwxyo">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-605" data-mp="23cmoap5qrqlc">{service.copy}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-606" data-mp="1ykl6yotpv9og">
          <a href="#quote" className="inline-flex items-center justify-center bg-brand-blue hover:bg-brand-hover text-white font-bold text-lg py-4 px-8 rounded-lg transition-colors shadow-lg shadow-brand-blue/20" data-id="element-607" data-mp="1yjjv4i4vmj5o">
            Get a Free Auto Glass Estimate
          </a>
        </div>
      </div>
    </section>;
}